import { initializeObservability } from '@psyomics/ui-common';

import { renderRoot } from './app/render-root';
import { getConfig } from './config';
import '@psyomics/ui-components/styles';

const config = getConfig();

initializeObservability({
  dsn: config.sentryDsn,
  environment: config.environment,
  hosts: [config.referralApiUrl],
});

renderRoot();
